export default __webpack_public_path__ + "static/media/packaging-desktop.f4715fdd.jpg";